import { useUserData } from '@lib/userData/UserDataProvider';
import { clx } from '@lib/utils';
import { AppLink } from '../components/AppLink';
import { AppTitle } from '../components/AppTitle';
import { Button } from '../components/Button';
import { FlexColPageContainer } from '../components/FlexColPageContainer';
import { WelcomeBalloons } from '../components/WelcomeBalloons';

export const metadata = {
  title: 'Welcome | Patchooli',
  description: 'Welcome to Patchooli',
};

const outlinesOn = false;
const outlineBaseClass = outlinesOn
  ? 'outline-2 outline-dashed ring-inset ring-2 ring-debug-red/50'
  : '';

export const WelcomePage = () => {
  const [userData] = useUserData();
  // console.log(
  //   `%cthis is the userData in WelcomePage:`,
  //   'background:#ffd040; color:#222;',
  //   userData
  // );
  const isLoggedIn = userData.firebaseUserId.trim() !== '';

  // console.log(
  //   '\x1b[31m%s\x1b[0m',
  //   `this is the ${isLoggedIn ? 'logged in' : 'logged out'} userData:`,
  //   userData
  // );

  // if (userData.startingPage) {
  //   redirect(userData.startingPage);
  // }

  return (
    <FlexColPageContainer className={clx(outlineBaseClass, 'outline-debug-red')}>
      {/* App Title */}
      <div
        className={clx(
          'flex basis-1/6 flex-col items-center justify-center',
          outlineBaseClass,
          'outline-debug-blue'
        )}
      >
        <AppTitle className="text-[17vw] md:text-[120px]" />
      </div>

      {/* Welcome Image Illustration */}
      <div
        className={clx(
          'flex min-h-0 w-full shrink basis-1/2 flex-col items-center justify-center py-4',
          outlineBaseClass
        )}
      >
        <WelcomeBalloons className="min-h-10" />
      </div>

      {/* CTA */}
      <div
        className={clx(
          'mb-[4vh] flex w-10/12 grow-0 basis-1/12 flex-col items-center justify-end',
          outlineBaseClass
        )}
      >
        <div className="flex w-full justify-center">
          <Button
            as={AppLink}
            variant="buttonPrimary"
            href={isLoggedIn ? '/mood-log-entry/step1' : '/login'}
            className="grow"
          >
            Next
          </Button>
        </div>
      </div>

      {/* Disclaimer Text */}
      <p
        className={clx(
          'max-h-12 w-10/12 max-w-sm basis-1/12 text-center text-xs leading-relaxed md:text-sm',
          outlineBaseClass
        )}
      >
        If you have persistent symptoms of depression or anxiety, talk to your healthcare provider.
      </p>
    </FlexColPageContainer>
  );
};
